import React from "react";
import { Screen } from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen';

const BusinessProcessesV2 = () => {
  const items = [
    {
      text: <span>Подберем<br />маршрут звонка<br />под ваш кейс</span>,
      color: '#5FC8E7',
      mobileOrder: 1
    },
    {
      text: <span>Распределим<br />звонки между<br />сотрудниками</span>,
      color: '#489BB3',
      mobileOrder: 3
    },
    {
      text: <span>Настроим отчеты<br />и уведомления</span>,
      color: '#F18D64',
      mobileOrder: 5
    },
    {
      text: <span>Подключим<br />дополнительные<br />модули</span>,
      color: '#8B6DBB',
      mobileOrder: 7
    },
    {
      text: <span>Выберем<br />устройства для<br />звонков</span>,
      color: '#00C69E',
      mobileOrder: 2
    },
    {
      text: <span>Расскажем<br />про детали<br />телефонии</span>,
      color: '#EFA5DF',
      mobileOrder: 4
    },
    {
      text: <span>Настроим<br />интеграцию</span>,
      color: '#6F6CFF',
      mobileOrder: 6
    },
    {
      text: <span>Подключим<br />виртуальный номер</span>,
      color: '#E4B078',
      mobileOrder: 8
    }
  ]

  return (
    <Screen
      id='implementation'
      title={<span>Внедрим телефонию в <StyledScreen.GreenText>бизнес-процессы</StyledScreen.GreenText></span>}
    >
      <Styled.ItemsContainer>
        <Styled.ItemsRow>
          {
            items.map(item => (
              <Styled.ItemWrapp mobileOrder={item.mobileOrder}>
                <Styled.Item color={item.color}>
                  <Styled.ItemInner>
                    <Styled.CheckIcon>
                      <img src={process.env.PUBLIC_DIR + '/images/check-v2.svg'} />
                    </Styled.CheckIcon>
                    {item.text}
                  </Styled.ItemInner>
                </Styled.Item>
              </Styled.ItemWrapp>
            ))
          }
        </Styled.ItemsRow>
      </Styled.ItemsContainer>
    </Screen>
  )
}

export { BusinessProcessesV2 }
